var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`status status--${_vm.translate}`},[(!_vm.noIcon)?_c('div',[_c('v-img',{attrs:{"width":"17px","src":require(`@/assets/${_vm.translate}-square.svg`)}})],1):_vm._e(),(!_vm.noText)?_c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.payment.status).toLowerCase())+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }